import type { DateValue } from '@internationalized/date';
import { startOfMonth, startOfYear, today } from '@internationalized/date';

export interface DateRangePreset {
  label: string;
  value: string;
  getDates: () => { start: DateValue; end: DateValue };
}

/**
 * Calculate date range for "last N days"
 */
const getLastNDays = (days: number): { start: DateValue; end: DateValue } => {
  const end = today('UTC');
  const start = end.subtract({ days: days - 1 });
  return { start, end };
};

/**
 * Dashboard presets - focused on recent periods for analytics
 */
export const DASHBOARD_PRESETS: DateRangePreset[] = [
  {
    label: 'filters.dateRange.presets.week',
    value: '7d',
    getDates: () => getLastNDays(7),
  },
  {
    label: 'filters.dateRange.presets.month',
    value: '30d',
    getDates: () => getLastNDays(30),
  },
  {
    label: 'filters.dateRange.presets.thisMonth',
    value: 'this_month',
    getDates: () => ({
      start: startOfMonth(today('UTC')),
      end: today('UTC'),
    }),
  },
  {
    label: 'filters.dateRange.presets.threeMonths',
    value: '90d',
    getDates: () => getLastNDays(90),
  },
  {
    label: 'filters.dateRange.presets.ytd',
    value: 'ytd',
    getDates: () => ({
      start: startOfYear(today('UTC')),
      end: today('UTC'),
    }),
  },
  {
    label: 'filters.dateRange.presets.custom',
    value: 'custom',
    getDates: () => getLastNDays(30),
  },
];

/**
 * Commission presets - use last 30 days as default for consistency with backend
 */
export const COMMISSION_PRESETS: DateRangePreset[] = [
  {
    label: 'filters.dateRange.presets.week',
    value: '7d',
    getDates: () => getLastNDays(7),
  },
  {
    label: 'filters.dateRange.presets.month',
    value: '30d',
    getDates: () => getLastNDays(30),
  },
  {
    label: 'filters.dateRange.presets.threeMonths',
    value: '90d',
    getDates: () => getLastNDays(90),
  },
  {
    label: 'filters.dateRange.presets.year',
    value: '365d',
    getDates: () => getLastNDays(365),
  },
  {
    label: 'filters.dateRange.presets.all',
    value: 'all',
    getDates: () => ({
      start: startOfYear(today('UTC').subtract({ years: 5 })),
      end: today('UTC'),
    }),
  },
];
